/**
 * 解决方案
 */

export default [
    {
        path: '/solution',
        name: 'solution',
        component: () => import('../../views/solve/solution.vue'),
        meta: {
            title: '解决方案'
        }
    },
    // {
    //     path: '/stuCareerCenterSolve',
    //     name: 'stuCareerCenterSolve',
    //     component: () => import('../../views/solve/stuCareerCenterSolve.vue'),
    //     meta: {
    //         title: '一站式学生职业规划与就业服务中心'
    //     }
    // },
    // {
    //     path: '/careerSpecialAdviceSolve',
    //     name: 'careerSpecialAdviceSolve',
    //     component: () => import('../../views/solve/careerSpecialAdviceSolve.vue'),
    //     meta: {
    //         title: '职业生涯特色咨询室'
    //     }
    // },
    // {
    //     path: '/careerSpaceSolve',
    //     name: 'careerSpaceSolve',
    //     component: () => import('../../views/solve/careerSpaceSolve.vue'),
    //     meta: {
    //         title: '生涯团辅空间'
    //     }
    // },
    // {
    //     path: '/careerPlanCenSolve',
    //     name: 'careerPlanCenSolve',
    //     component: () => import('../../views/solve/careerPlanCenSolve.vue'),
    //     meta: {
    //         title: '职业规划与智慧就业中心'
    //     }
    // },
    // {
    //     path: '/stuDevelopCenSolve',
    //     name: 'stuDevelopCenSolve',
    //     component: () => import('../../views/solve/stuDevelopCenSolve.vue'),
    //     meta: {
    //         title: '学生发展指挥中心'
    //     }
    // }
]



// WEBPACK FOOTER //
// ./src/router/solve/solve.js